module.exports = __webpack_public_path__ + "img/sy_16.58661392.png";